import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { EmailGridDto, EmailSearch, LanguageApi, LanguageGridDto, LanguageSearchDto } from "../../../../api";
import { useHistory } from "react-router";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { ERoutes } from "../../../../ERoutes";
import { useGlobalData } from "../../../../contexts";

export interface ILanguageListPageProps {}

export const LanguageListPage: React.FunctionComponent<ILanguageListPageProps> = (props) => {
  const api = useApiService(LanguageApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const history = useHistory();

  const searchFunction = React.useCallback(
    (sObj) => {
      sObj.languageId = currentLanguage.languageId;
      console.log("lang", sObj.languageId);
      return api.baseSearch(LanguageSearchDto.fromJS(sObj));
    },
    [api]
  );
  const exportFunction = React.useCallback((sObj) => api.exportXlsFile(EmailSearch.fromJS(sObj)), [api]);

  const goToEditPage = React.useCallback((isEditMode: boolean, id: number) => {
    history.push(`${ERoutes.language}/${id}/detail/${isEditMode ? "edit" : "view"}`);
  }, []);

  const getSearchCriterias = React.useCallback(() => api.getSearchCriterias(true), [api]);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: LanguageGridDto) => (
          <ButtonContainer>
            <ViewButton minimal={true} onClick={() => goToEditPage(false, row.languageId)} />
            <EditButton minimal={true} onClick={() => goToEditPage(true, row.languageId)} />
          </ButtonContainer>
        ),
      },
      {
        fieldName: "languageCode",
        header: () => t(ETLCodes.Iso2LanguageCode),
        autoFitContent: true,
      },
      {
        fieldName: "name",
        header: () => t(ETLCodes.Name),
      },
    ],
    []
  );
  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={getSearchCriterias}
      searchFunction={searchFunction}
      exportFunction={exportFunction}
      sortKeys={{ languageCode: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Languages) }]}
      addFunc={() => goToEditPage(true, -1)}
    />
  );
};
